import { useMediaQuery, useTheme } from '@material-ui/core';

export default function useDesktopDisplay() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
